import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { formatShortDateWithoutTimezone } from '@ibk/shared-utils';
import { CARD_STATUS_FILTER_LABEL_KEYS } from '../../../../utils/cardStatusUtils';
import { AppliedFilterChip } from '../../../AppliedFilterChip';
export function FilterChip({ appliedFilters, onRemove, testIdIdentifier }) {
    const { t } = useTranslation();
    const chipData = useMemo(() => {
        if (!appliedFilters)
            return null;
        const hasFiltersExceptName = () => {
            return ((appliedFilters.startDate !== undefined && appliedFilters.endDate !== undefined) ||
                appliedFilters.contractType.length > 0 ||
                appliedFilters.cardStatus.length > 0 ||
                appliedFilters.jobRole.length > 0 ||
                appliedFilters.costCenter.length > 0 ||
                appliedFilters.department.length > 0 ||
                appliedFilters.category.length > 0 ||
                appliedFilters.employmentBond.length > 0 ||
                appliedFilters.branch.length > 0 ||
                appliedFilters.union.length > 0);
        };
        if (!hasFiltersExceptName())
            return null;
        const getFirstFilterLabel = () => {
            const labelExtractors = [
                () => {
                    if (appliedFilters.startDate && appliedFilters.endDate) {
                        const startDate = formatShortDateWithoutTimezone(appliedFilters.startDate);
                        const endDate = formatShortDateWithoutTimezone(appliedFilters.endDate);
                        if (startDate && endDate) {
                            return `${startDate} - ${endDate}`;
                        }
                    }
                    return null;
                },
                () => (appliedFilters.contractType.length > 0 ? appliedFilters.contractType[0] : null),
                () => appliedFilters.cardStatus.length > 0 ? t(CARD_STATUS_FILTER_LABEL_KEYS[appliedFilters.cardStatus[0]]) : null,
                () => (appliedFilters.jobRole.length > 0 ? appliedFilters.jobRole[0] : null),
                () => (appliedFilters.costCenter.length > 0 ? appliedFilters.costCenter[0] : null),
                () => (appliedFilters.department.length > 0 ? appliedFilters.department[0] : null),
                () => (appliedFilters.category.length > 0 ? appliedFilters.category[0] : null),
                () => (appliedFilters.employmentBond.length > 0 ? appliedFilters.employmentBond[0] : null),
                () => (appliedFilters.branch.length > 0 ? appliedFilters.branch[0] : null),
                () => (appliedFilters.union.length > 0 ? appliedFilters.union[0] : null),
            ];
            return labelExtractors.reduce((acc, extractor) => {
                return acc ?? extractor();
            }, null);
        };
        const countTotalFilters = () => {
            const countExtractors = [
                () => (appliedFilters.startDate && appliedFilters.endDate ? 1 : 0),
                () => appliedFilters.contractType.length,
                () => appliedFilters.cardStatus.length,
                () => appliedFilters.jobRole.length,
                () => appliedFilters.costCenter.length,
                () => appliedFilters.department.length,
                () => appliedFilters.category.length,
                () => appliedFilters.employmentBond.length,
                () => appliedFilters.branch.length,
                () => appliedFilters.union.length,
            ];
            return countExtractors.reduce((total, extractor) => total + extractor(), 0);
        };
        const firstFilterLabel = getFirstFilterLabel();
        if (!firstFilterLabel)
            return null;
        const totalFilters = countTotalFilters();
        const remainingCount = totalFilters - 1;
        const label = remainingCount > 0 ? `${firstFilterLabel} + ${remainingCount}` : firstFilterLabel;
        return {
            key: 'all-filters',
            label,
        };
    }, [appliedFilters, t]);
    if (!chipData)
        return null;
    return (_jsx(AppliedFilterChip, { label: chipData.label, onRemove: onRemove, removeAriaLabel: t('clearFilters'), chipTestId: `chip${testIdIdentifier}${chipData.key}`, labelTestId: `span${testIdIdentifier}${chipData.key}Text`, removeTestId: `button${testIdIdentifier}${chipData.key}Close` }));
}
